<template>
  <div>
    <v-alert
      :value="!temporada.temporadaHabilitada"
      type="warning"
      class="mb-4"
    >
      La temporada seleccionada fue deshabilitada. No podrá modificar los datos
      de las fichas y actividades de esta temporada.
    </v-alert>

    <template v-if="isConfiguracionMissing">
      <h3 class="text-h4 text-md-center my-3">Configuración</h3>

      <v-alert :value="temporada.temporadaHabilitada" type="info">
        Cargue algunos datos de configuración para poder continuar con el
        ingreso de actividades en las fichas.
      </v-alert>

      <v-row>
        <v-col v-if="isInventarioMissing" cols="12" md="6">
          <v-card :to="{ name: 'Maquinas' }" class="pa-3">
            <v-card-title>
              <v-icon class="pr-3">fa-tractor</v-icon>
              <span class="headline"> Máquinas </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col v-if="isPersonalMissing" cols="12" md="6">
          <v-card :to="{ name: 'Personal' }" class="pa-3">
            <v-card-title>
              <v-icon class="pr-3">fa-users</v-icon>
              <span class="headline"> Personal </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col v-if="isFichaAgricolaMissing" cols="12" md="6">
          <v-card :to="{ name: 'Fichas' }" class="pa-3">
            <v-card-title>
              <v-icon class="pr-3">fa-file-alt</v-icon>
              <span class="headline"> Fichas </span>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <!-- <h3 class="text-h4 text-md-center">Actividades</h3>

      <v-row class="mt-1">
        <v-col class="pb-0" cols="12" md="6">
          <v-card :to="{ name: 'Precipitacion' }" class="pa-md-3">
            <v-card-title>
              <v-icon class="pr-3">fa-vial</v-icon>
              <span class="headline">
                Precipitación
              </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col
            v-for="rubro in listaRubro"
            :key="rubro.idRubro"
            cols="12"
            md="6"
            class="pb-0"
        >
          <v-card :to="{ name: 'Actividad', params: { rubroSlug: rubro.rubroSlug } }" class="pa-md-3">
            <v-card-title>
              <v-icon class="pr-3">fa-{{ rubro.icono }}</v-icon>
              <span class="headline">
                {{ rubro.nombre }}
              </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col class="pb-0" cols="12" md="6">
          <v-card :to="{ name: 'RendimientoCosecha' }" class="pa-md-3">
            <v-card-title>
              <v-icon class="pr-3">fa-file-invoice-dollar</v-icon>
              <span class="headline">
                Rendimiento cosecha
              </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card :to="{ name: 'Alquiler' }" class="pa-md-3">
            <v-card-title>
              <v-icon class="pr-3">fa-hand-holding-usd</v-icon>
              <span class="headline">
                Alquiler
              </span>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row> -->
      <v-row class="mx-auto">
        <v-col cols="6" md="2">
          <fh-date
            :min="temporada.periodoInicio"
            :max="fechaHasta || temporada.periodoFin"
            v-model="fechaDesde"
            label="Fecha desde"
          ></fh-date>
        </v-col>
        <v-col cols="6" md="2">
          <fh-date
            v-model="fechaHasta"
            label="Fecha hasta"
            :min="fechaDesde || temporada.periodoInicio"
            :max="temporada.periodoFin"
          ></fh-date>
        </v-col>
        <v-col class="d-flex align-center">
          <v-btn @click="filtrar()" class="primary">Filtrar</v-btn>
        </v-col>
      </v-row>
      <v-card class="mx-auto" flat>
        <v-card-text class="px-0">
          <fh-data-table
            :headers="headers"
            :items="listaTrabajo"
            :search="search"
            :options.sync="options"
            :mobile-breakpoint="0"
            class="fh-striped-table text-no-wrap"
          >
            <template v-slot:item="props">
              <tr>
                <td>
                  <v-btn small text icon @click="abrir(props.item)">
                    <v-icon small>fa-eye</v-icon>
                  </v-btn>
                  <v-btn @click="editar(props.item)" text icon>
                    <v-icon small>fa-pen</v-icon>
                  </v-btn>
                </td>
                <td>{{ props.item.fecha | fhDate }}</td>
                <td>
                  {{ props.item.fichaAgricola.nombre }}
                </td>
                <td>{{ props.item.tipoTrabajo.nombre }}</td>
                <td class="text-right">
                  {{ props.item.fichaAgricola.superficie }}
                </td>
                <td>
                  {{ props.item.fichaAgricola.variedad.nombre }}
                </td>
                <td class="text-right">
                  {{ costoTotalSuperficie(props.item) | fhIntegerNumber }}
                </td>
                <td class="text-right red--text">
                  {{ props.item.costoTotal | fhIntegerNumber }}
                </td>
                <td>
                  <p
                    v-for="trabajoT in props.item.trabajoTratamientoList"
                    :key="`${trabajoT.idTrabajoTratamiento}T${trabajoT.idTrabajoParcela}`"
                    class="my-1"
                  >
                    ∙
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <span class="font-weight-medium"
                            >{{ trabajoT.productoAgricultor.nombre }}
                          </span>
                          <span class="green--text text--darken-1"
                            >{{ trabajoT.cantidadTotal }}
                          </span>
                          {{ trabajoT.productoAgricultor.unidadMedida.nombre }}
                          <span class="red--text text-darken-1"
                            >{{ trabajoT.costoTotal | fhNumber }} </span
                          >Gs.
                        </span>
                      </template>
                      <span
                        >{{ trabajoT.precioUnitario | fhNumber }} Gs/
                        {{ trabajoT.productoAgricultor.unidadMedida.nombre }}
                        <br />
                        {{ trabajoT.productoAgricultor.nombre }}<br />
                        <span v-if="trabajoT.productoAgricultor">
                          {{ trabajoT.productoAgricultor.principioActivo }}
                        </span>
                        <span v-else-if="trabajoT.producto.productoCultivo">
                          {{
                            trabajoT.producto.productoCultivo.variedad.nombre
                          }}
                        </span>
                      </span>
                    </v-tooltip>
                  </p>
                </td>
                <td class="text-right red--text">
                  {{
                    sumarCostoTrabajoTratamiento(
                      props.item.trabajoTratamientoList
                    )
                  }}
                </td>
                <td>
                  <p
                    v-for="trabajoP in props.item.trabajoPersonalList"
                    :key="`${trabajoP.idTrabajoPersonal}P${trabajoP.idTrabajoParcela}`"
                    class="my-1"
                  >
                    ∙
                    <span class="font-weight-medium"
                      >{{ trabajoP.personal.nombrePersonal }}
                    </span>
                    <span class="green--text text--darken-1"
                      >{{ trabajoP.totalHoras }} </span
                    >hs
                    <span class="red--text text-darken-1"
                      >{{ trabajoP.costoTotal | fhNumber }} </span
                    >Gs.
                  </p>
                </td>
                <td class="text-right red--text">
                  {{
                    sumarCostoTrabajoPersonal(props.item.trabajoPersonalList)
                  }}
                </td>
                <td>
                  <p
                    v-for="trabajoM in props.item.trabajoMaquinariaList"
                    :key="`${trabajoM.idTrabajoMaquinaria}M${trabajoM.idTrabajoParcela}`"
                    class="my-1"
                  >
                    ∙
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <span class="font-weight-medium"
                            >{{ trabajoM.inventario.maquina.nombreMaquina }}
                          </span>
                          <span class="green--text text--darken-1"
                            >{{ trabajoM.cantidad }} </span
                          >{{
                            trabajoM.inventario.maquina.nombreUnidadMedidaCosto
                          }}
                          <span class="red--text text-darken-1"
                            >{{ trabajoM.costoTotal | fhNumber }} </span
                          >Gs.
                        </span></template
                      ><span>
                        {{ trabajoM.costoUnitario | fhNumber }} Gs/{{
                          trabajoM.inventario.maquina.nombreUnidadMedidaCosto
                        }}
                        <br />
                        {{ trabajoM.inventario.maquina.nombreTipoImplemento }}
                        <br />
                        {{ trabajoM.inventario.maquina.nombreTipoMaquina }}
                      </span></v-tooltip
                    >
                  </p>
                </td>
                <td class="text-right red--text">
                  {{
                    sumarCostoTrabajoMaquinaria(
                      props.item.trabajoMaquinariaList
                    )
                  }}
                </td>
                <td>
                  {{ props.item.comentario }}
                </td>
              </tr>
            </template>
          </fh-data-table>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import FhContainer from "@/components/FhContainer";
import { mapActions, mapGetters, mapState } from "vuex";
import FhDataTable from "@/components/FhDataTable.vue";
import FhDate from "@/components/FhDate";
import TableRowsPerPageService from "@/services/TableRowsPerPageService";
import Vue from "vue";

export default {
  name: "AgroHome",
  components: { FhContainer, FhDataTable, FhDate },
  data() {
    return {
      search: null,
      fechaDesde: null,
      fechaHasta: null,
      configuracionList: [
        { title: "Máquinas", icon: "fa-tractor", route: "Maquinas" },
        { title: "Personal", icon: "fa-users", route: "Personal" },
        { title: "Fichas", icon: "fa-file-alt", route: "Fichas" },
      ],
      headers: [
        { text: "Edición", align: "left", filterable: false, sortable: false },
        { text: "Fecha", value: "fecha", align: "left", filterable: false },
        { text: "Ficha", value: "fichaAgricola.nombre", align: "left" },
        { text: "Trabajo", value: "tipoTrabajo.nombre", align: "left" },
        {
          text: "Superficie Ha",
          value: "fichaAgricola.superficie",
          align: "right",
          filterable: false,
        },
        {
          text: "Variedad",
          value: "fichaAgricola.variedad.nombre",
          align: "left",
          sortable: false,
        },
        {
          text: "Costo/Total Ha",
          value: "costoTotal",
          align: "right",
          filterable: false,
          sortable: true,
        },
        {
          text: "Costo Total",
          value: "costoTotal",
          align: "right",
          filterable: false,
          sortable: true,
        },
        {
          text: "Trabajo/Tratamiento",
          align: "left",
          filterable: false,
          sortable: false,
        },
        {
          text: "Costo Trab. Tratamiento",
          align: "right",
          sortable: true,
          filterable: false,
        },
        {
          text: "Trabajo/Personal",
          align: "left",
          filterable: false,
          sortable: false,
        },
        {
          text: "Costo Trab. Personal",
          align: "right",
          filterable: false,
          sortable: true,
        },
        {
          text: "Trabajo/Maquinaria",
          align: "left",
          filterable: false,
          sortable: false,
        },
        {
          text: "Costo Trab. Maquinaria",
          align: "right",
          filterable: false,
          sortable: true,
        },
        {
          text: "Comentario",
          value: "comentario",
          align: "left",
          filterable: false,
          sortable: false,
        },
      ],
      options: {
        sortBy: ["fecha"],
        descending: false,
        itemsPerPage: TableRowsPerPageService.get(),
      },
    };
  },
  watch: {
    updateAgricultorLists: async function (value) {
      if (value === true) {
        await this.fetchListas();
        await this.setUpdateAgricultorListsFalse();
      }
    },
    "options.itemsPerPage": function (val) {
      if (val) {
        TableRowsPerPageService.set(val);
      }
    },
    temporada: {
      handler(oldValue) {
        if (oldValue) {
          this.filtrar();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("rubros", ["listaRubro"]),
    ...mapState("temporada", ["temporada"]),
    ...mapState("maquinas", ["listaInventario"]),
    ...mapState("personal", ["listaPersonal"]),
    ...mapState("fichas", ["listaFichaAgricola"]),
    ...mapState("trabajos", ["listaTrabajo"]),
    ...mapState("agricultor", ["updateAgricultorLists"]),
    ...mapGetters("rubros", ["getRubroByIdTipoTrabajo"]),
    isInventarioMissing() {
      return this.listaInventario.length === 0;
    },
    isPersonalMissing() {
      return this.listaPersonal.length === 0;
    },
    isFichaAgricolaMissing() {
      return this.listaFichaAgricola.length === 0;
    },
    isConfiguracionMissing() {
      return (
        this.isInventarioMissing ||
        this.isPersonalMissing ||
        this.isFichaAgricolaMissing
      );
    },
  },
  methods: {
    ...mapActions("rubros", ["fetchListaRubro"]),
    ...mapActions("maquinas", ["fetchListaInventario"]),
    ...mapActions("personal", ["fetchListaPersonal"]),
    ...mapActions("fichas", ["fetchListaFichaAgricola", "setFichaAgricola"]),
    ...mapActions("trabajos", ["fetchListaTrabajo"]),
    ...mapActions("agricultor", ["setUpdateAgricultorListsFalse"]),
    async fetchListas() {
      let listaRubro = this.fetchListaRubro();
      let listaInventario = this.fetchListaInventario();
      let listaPersonal = this.fetchListaPersonal();
      // let listaFichaAgricola = this.fetchListaFichaAgricola()

      await listaRubro;
      await listaInventario;
      await listaPersonal;
      // await listaFichaAgricola
    },
    sumarCostoTrabajoPersonal(listaTrabajoPersonal, value = false) {
      let total = listaTrabajoPersonal.reduce(
        (total, trabajo) => total + trabajo.costoTotal,
        0
      );
      if (value) {
        return total;
      }
      if (total > 0) {
        return `${Vue.filter("fhIntegerNumber")(total)} Gs`;
      }
      return "";
    },
    sumarCostoTrabajoTratamiento(trabajoTratamientoList, value = false) {
      let total = trabajoTratamientoList.reduce(
        (total, trabajo) => total + trabajo.costoTotal,
        0
      );
      if (value) {
        return total;
      }
      if (total > 0) {
        return `${Vue.filter("fhIntegerNumber")(total)} Gs`;
      }
      return "";
    },
    sumarCostoTrabajoMaquinaria(trabajoMaquinariaList, value = false) {
      let total = trabajoMaquinariaList.reduce(
        (total, trabajo) => total + trabajo.costoTotal,
        0
      );
      if (value) {
        return total;
      }
      if (total > 0) {
        return `${Vue.filter("fhIntegerNumber")(total)} Gs`;
      }
      return "";
    },
    costoTotalSuperficie(item) {
      return Math.ceil(item.costoTotal / item.fichaAgricola.superficie);
    },
    async abrir(item) {
      await this.setFichaAgricola(item.fichaAgricola.idFichaAgricola);
      let rubro = this.getRubroByIdTipoTrabajo(item.tipoTrabajo.idTipoTrabajo);
      this.$router
        .push({
          name: "DetalleActividad",
          params: {
            rubroSlug: rubro.rubroSlug,
            id: item.idTrabajoParcela,
          },
        })
        .catch();
    },
    async editar(item) {
      await this.setFichaAgricola(item.fichaAgricola.idFichaAgricola);
      let rubro = this.getRubroByIdTipoTrabajo(item.tipoTrabajo.idTipoTrabajo);
      this.$router
        .push({
          name: "EditarActividad",
          params: { rubroSlug: rubro.rubroSlug, id: item.idTrabajoParcela },
        })
        .catch();
    },
    async filtrar() {
      await this.fetchListaTrabajo([
        true,
        null,
        this.fechaDesde,
        this.fechaHasta,
      ]);
    },
  },
  async created() {
    await this.fetchListas();
    await this.fetchListaTrabajo([null, null, null]);
  },
};
</script>
